const checkDecimals = (
    value: string,
    minDecimal: number,
    maxDecimal: number = minDecimal
) => {
    if (!value.includes('.') || !value.includes(',')) return true;

    const formattedValue = value.replace(',', '.');
    const decimalPlaces = formattedValue.split('.')[1].length;

    return decimalPlaces >= minDecimal && decimalPlaces <= maxDecimal;
};

export default checkDecimals;
